export default __webpack_public_path__ + "static/Quickinstallation_14-cb19847e15d70a71df9b383e61c5be29.webp";